import { useEffect } from 'react';
import { RECAPTCHA_SCRIPT_URL } from 'constants/app-const';

export const useRecaptchaScript = () => {
  useEffect(() => {
    const isScriptExists = document.querySelector(`script[src="${RECAPTCHA_SCRIPT_URL}"]`);

    if (!isScriptExists) {
      const script = document.createElement('script');
      script.src = RECAPTCHA_SCRIPT_URL;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
};
